import { cn } from "@bentolabs/kit/utils";
import { Dialog } from "radix-ui";
import { Drawer as VaulDrawer } from "vaul";

export const Drawer = (props: Dialog.DialogProps) => {
  return <VaulDrawer.Root direction="right" {...props} />;
};

Drawer.Trigger = (props: Dialog.DialogTriggerProps) => {
  return <VaulDrawer.Trigger {...props} asChild />;
};

Drawer.Content = ({ className, ...props }: Dialog.DialogContentProps) => {
  return (
    <VaulDrawer.Portal>
      <VaulDrawer.Overlay className="fixed inset-0 bg-black/40" />
      <VaulDrawer.Content
        {...props}
        style={
          { "--initial-transform": "calc(100% + 8px)" } as React.CSSProperties
        }
        className={cn(
          "fixed top-2 right-3 bottom-2 z-10 overflow-hidden outline-none",
          "bg-onyx flex flex-col rounded-2xl",
          "w-[calc(100%-10px)] md:w-lg",
          className
        )}
      />
    </VaulDrawer.Portal>
  );
};
